var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBQuestionCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-question-circle",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-question-circle1",
    serifid: "iconB-question-circle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,12c0,6.075 -4.925,11 -11,11c-6.075,0 -11,-4.925 -11,-11c0,-6.075 4.925,-11 11,-11c6.075,0 11,4.925 11,11Zm-2,0c0,-4.971 -4.029,-9 -9,-9c-4.971,0 -9,4.029 -9,9c0,4.971 4.029,9 9,9c4.971,0 9,-4.029 9,-9Zm-8.005,1.205c-0,0.076 0.003,0.187 0.003,0.188c0.001,0.005 0.001,0.01 0.001,0.015c-0,0.543 -0.46,1.002 -1.003,1.002c-0.543,-0 -1.002,-0.459 -1.002,-1.002l-0,-0.754c-0,-0.332 0.165,-0.663 0.493,-0.873l-0.027,0.02c0.005,-0.003 2.72,-1.669 2.72,-1.669c0.002,-0.001 0.003,-0.002 0.005,-0.003c0.369,-0.213 0.577,-0.538 0.577,-0.961c0,-0.633 -0.569,-1.165 -1.249,-1.165l-2.407,0c-0.637,0 -1.122,0.528 -1.122,1.165c-0,0.543 -0.46,1.002 -1.003,1.002c-0.543,0 -1.002,-0.459 -1.002,-1.002c-0,-1.766 1.403,-3.17 3.169,-3.17l2.408,0c1.805,0.001 3.21,1.402 3.169,3.167c-0,0.001 -0,0.002 -0,0.003c-0,1.087 -0.59,2.128 -1.541,2.717l-0.002,0.001c0,0 -1.689,1.02 -2.187,1.319Zm-0.993,2.797c0.553,0 1.002,0.449 1.002,1.001c-0,0.553 -0.449,1.002 -1.002,1.002c-0.552,-0 -1.001,-0.449 -1.001,-1.002c-0,-0.552 0.449,-1.001 1.001,-1.001Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBQuestionCircle);
export default __webpack_public_path__ + "static/media/iconB-question-circle.79b38dd33135641b711d5748c4fa264b.svg";
export { ForwardRef as ReactComponent };